module.exports = __webpack_public_path__ + "static/img/certificate2.769e3c49.png";